import React from 'react';

import { LocalizableText } from '~/@components/LocalizableText';
import { useLandfillRules } from '~/@store/permissions';

import { PermissionsTable } from './PermissionsTable';

export const LandfillPermissions = () => {
    const rules = useLandfillRules();
    const extendedColumns = [
        {
            field: 'subject' as const,
            title: <LocalizableText code={'PermissionsPage.subject'} />,
        },
    ];

    return (
        <PermissionsTable
            title={<LocalizableText code={'PermissionsPage.landfill'} />}
            rules={rules}
            extendedColumns={extendedColumns}
        />
    );
};
